import { Howl } from 'howler';

export class Sound {
  private static pressSound = new Howl({
    src: [require('@/assets/sounds/button_press.mp3')],
  });

  public static press() {
    this.pressSound.play();
  }
}
